import React from "react";
import {
  Button,
  ButtonGroup,
  Container,
  Dropdown,
  Offcanvas,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { BsSuitHeart, BsBagCheck } from "react-icons/bs";
import { GoTriangleDown } from "react-icons/go";
import { AiOutlineBars,AiOutlineHome,AiOutlinePlus } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { IoCallOutline } from "react-icons/io5";
import useAuth from "../../../Hooks/useAuth";
const Header = () => {
  const navigate = useNavigate();
  const {
    handleShow,
    handleClose,
    sideBar,
    setSideBar,
    show,
    viewCartFromSideBar,
  } = useAuth();



  return (
    <div className="header py-2">
      {/* navigation area for mobile begin  */}
      <div className="nagigation">
        <div className="navigation-container">
          <Link to="/" className="navigation-item">
            <AiOutlineHome/>
          </Link>
          <Link to="/category" className="navigation-item">
            <AiOutlineBars/>
          </Link>
          <Link to="/products" className="navigation-item">
            <AiOutlinePlus/>
          </Link>
          <Link to="/profile" className="navigation-item">
            <span className="count-number">5</span>
            <BsBagCheck/>
          </Link>
          <Link to="/contact" className="navigation-item">
            <IoCallOutline/>
          </Link>
        </div>
      </div>
      {/* navigation area for mobile end  */}
      <Offcanvas placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fw-light">Cart Items</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="cart-item">
            <div className="row align-items-center border-bottom py-1">
              <div className="col-7">
                <div className="cart-details">
                  <span>Women Plazo</span>
                  <br />
                  <span>1 X $12.33</span>
                </div>
              </div>
              <div className="col-3">
                <div className="item-img">
                  <img
                    src={require("../../../images/features/feature1.png")}
                    className="w-100 h-100"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-2 text-center">
                <IoIosRemoveCircleOutline className="text-dark" />
              </div>
            </div>
            <div className="row align-items-center my-2 border-bottom py-1">
              <div className="col-7">
                <div className="cart-details">
                  <span>Women Plazo</span>
                  <br />
                  <span>1 X $12.33</span>
                </div>
              </div>
              <div className="col-3">
                <div className="item-img">
                  <img
                    src={require("../../../images/features/feature3.png")}
                    className="w-100 h-100"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-2 text-center">
                <IoIosRemoveCircleOutline className="text-dark" />
              </div>
            </div>
            <div className="row align-items-center my-2 border-bottom py-1">
              <div className="col-7">
                <div className="cart-details">
                  <span>Women Plazo</span>
                  <br />
                  <span>1 X $12.33</span>
                </div>
              </div>
              <div className="col-3">
                <div className="item-img">
                  <img
                    src={require("../../../images/features/feature4.png")}
                    className="w-100 h-100"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-2 text-center">
                <IoIosRemoveCircleOutline className="text-dark" />
              </div>
            </div>
            <div className="row align-items-center my-2 border-bottom py-1">
              <div className="col-7">
                <div className="cart-details">
                  <span>Women Plazo</span>
                  <br />
                  <span>1 X $12.33</span>
                </div>
              </div>
              <div className="col-3">
                <div className="item-img">
                  <img
                    src={require("../../../images/features/feature5.png")}
                    className="w-100 h-100"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-2 text-center">
                <IoIosRemoveCircleOutline className="text-dark" />
              </div>
            </div>
            <div className="row align-items-center my-2 border-bottom py-1">
              <div className="col-7">
                <div className="cart-details">
                  <span>Women Plazo</span>
                  <br />
                  <span>1 X $12.33</span>
                </div>
              </div>
              <div className="col-3">
                <div className="item-img">
                  <img
                    src={require("../../../images/features/feature2.png")}
                    className="w-100 h-100"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-2 text-center">
                <IoIosRemoveCircleOutline className="text-dark" />
              </div>
            </div>
            <Button
              onClick={() => viewCartFromSideBar(navigate)}
              variant="dark w-100 my-1"
            >
              View Cart
            </Button>
            <Link to="/checkout">
              <Button variant="primary w-100 my-1">Check Out</Button>
            </Link>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Container>
        <div className="header-container">
          <div className="logo-container">
            <div className="sm-screen d-none">
              <AiOutlineBars onClick={() => setSideBar(!sideBar)} />
            </div>
            <Link to="/" className="logo">
              <img
                src={require("../../../images/logo/gApparel.png")}
                alt=""
                className="w-100"
              />
            </Link>
          </div>
          <div className={`menu-container ${sideBar ? "show-menu" : ""}`}>
            <div className="sm-screen">
              <div
                onClick={() => setSideBar(!sideBar)}
                className="close-sidebar"
              >
                <FaTimes />
              </div>
            </div>
            <div className="sm-screen">
              <div className="w-75 mx-auto p-2">
                <img
                  src={require("../../../images/logo/gApparel.png")}
                  alt=""
                  className="w-100"
                />
              </div>
            </div>
            <ul className="all-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="position-relative">
                <Link to="#">
                  Pages
                  <GoTriangleDown />
                </Link>
                <div className="products-hover">
                  <ul>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/products">
                        All Products
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/products/1">
                        Product Details
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/checkout">
                        Checkout
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/track">
                        Track Order
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/about">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/contact">
                        Contact
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/login">
                        Login
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/profile">
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="*">
                        404 Page
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <Link to="#">
                  Shop
                  <GoTriangleDown />
                </Link>
                <div className="products-hover">
                  <ul>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/products">
                        <span>Uttara,Dhaka.</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Dhanmondi,Dhaka</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Mirpur,Dhaka</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Abdullahpur,Dhaka</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Gulshan,Dhaka</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Baridhara,Dhaka</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Uttara,Dhaka.</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        <span>Dhanmondi,Dhaka</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>Mirpur,Dhaka</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <Link to="#">
                  Products
                  <GoTriangleDown />
                </Link>
                <div className="products-hover">
                  <ul>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="/products">
                        All Products
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        New Arrival
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Gents Style
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Women Fashion
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Kids Cloths
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Babys wear
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Formal Dresses
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Best Sale
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Most View
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Todays Deal
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => setSideBar(false)} to="#">
                        Offer for Today
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="icon-container">
            <div className="icons">
              <Dropdown as={ButtonGroup}>
                <Dropdown.Toggle id="dropdown-split-basic">
                  <div className="position-relative">
                    <BsSuitHeart className="fs-4"/>
                    <span className="count-number">2</span>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div className="wishlist-container">
                    <div className="cart-item">
                      <div className="row align-items-center my-2 border-bottom py-1">
                        <div className="col-7">
                          <div className="cart-details">
                            <span>Women Plazo</span>
                            <br />
                            <span>1 X $12.33</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="item-img">
                            <img
                              src={require("../../../images/features/feature1.png")}
                              className="w-100 h-100"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-2 text-center">
                          <IoIosRemoveCircleOutline className="text-dark" />
                        </div>
                      </div>
                      <div className="row align-items-center my-2 border-bottom py-1">
                        <div className="col-7">
                          <div className="cart-details">
                            <span>Women Plazo</span>
                            <br />
                            <span>1 X $12.33</span>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="item-img">
                            <img
                              src={require("../../../images/features/feature2.png")}
                              className="w-100 h-100"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-2 text-center">
                          <IoIosRemoveCircleOutline className="text-dark" />
                        </div>
                      </div>
                      <Button variant="dark w-100 my-1">
                        Add to Cart
                      </Button>
                      <Button variant="primary w-100 my-1">Order Now</Button>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              <div className="position-relative mx-2">
                <BsBagCheck onClick={handleShow} className="pointer fs-4" />
                <span className="count-number">5</span>
              </div>
              <Link to="/profile" className="icon-box ms-2">
                <img
                  src={require("../../../images/users/user3.png")}
                  alt=""
                  className="w-100 h-100"
                />
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
